<script setup lang="ts">
const data = [
    {
        title: "سرشماره 9169",
        desc: "از 300 هزارتومان",
        path: "/numbers/",
        btnTxt: "مشاهده لیست خطوط",
    },
    {
        title: "سرشماره‌ 8164",
        desc: "از 500 هزارتومان",
        path: "/numbers/",
        btnTxt: "مشاهده لیست خطوط",
    },
    {
        title: "سرشماره‌ 8721",
        desc: "از 1میلیون تومان",
        path: "/numbers/",
        btnTxt: "مشاهده لیست خطوط",
    },
    {
        title: "سرشماره‌ 8280",
        desc: "از 1 میلیون و 500 هزار تومان",
        path: "/numbers/",
        btnTxt: "مشاهده لیست خطوط",
    },
    {
        title: "خطوط 4 رقمی مخابرات",
        desc: "تماس بگیرید",
        path: "/products/4-digit-line/",
        btnTxt: "اطلاعات بیشتر",
    },
    {
        title: "خطوط 5 رقمی مخابرات",
        desc: "تماس بگیرید",
        path: "/products/5-digit-line/",
        btnTxt: "اطلاعات بیشتر",
    },
];
const modalsStore = useModalsStore();
const props = defineProps<{
    title: string,
    desc: string,
    excludeEightAndNine?: boolean
}>();

function handleOpenModal() {
    modalsStore.openModal('CTA');
}
</script>

<template>
    <SectionsBase id="prefixes" class="bg-linear-to-b from-transparent to-primary-100">
      <div class="container">
        <ChipsDivider>خطوط</ChipsDivider>
        <h2>{{ props.title }}</h2>
        <p class="text-body1-semibold text-gray-400 text-center my-6">{{ props.desc }}</p>
        <Button
          :append-icon="{ name: 'solar:round-alt-arrow-left-bold' }"
          pill
          @click="handleOpenModal"
          class="mx-auto"
        >
          ارتباط با کارشناس فروش
        </Button>
        <template v-if="props.excludeEightAndNine">
          <div class="flex flex-col lg:flex-row items-center justify-center gap-5.5 mt-12">
            <CardsPrefix
              v-for="prefix in data.slice(0, 4)"
              :key="prefix.title"
              :prefix="prefix"
            />
          </div>
        </template>
        <template v-else>
          <div class="flex flex-col lg:flex-row items-center justify-center gap-8 mt-12">
            <CardsPrefix
              v-for="prefix in data.slice(0, 3)"
              :key="prefix.title"
              :prefix="prefix"
            />
          </div>
          <div class="flex flex-col lg:flex-row items-center justify-center gap-8 mt-8">
            <CardsPrefix
              v-for="prefix in data.slice(3)"
              :key="prefix.title"
              :prefix="prefix"
            />
          </div>
        </template>
      </div>
    </SectionsBase>
</template>